export const LOGO_URL =
  "https://nmcregistered.org.uk/uploads/assets/logo_ajustado.png";
export const BACKGROUND_IMG =
  "https://nmcregistered.org.uk/uploads/assets/background.jpg";
